import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <div className="font-heading text-6xl font-extrabold tracking-tight text-brand-orange">404</div>
      <p className="mt-2 text-sm text-muted-foreground">This page doesn't exist.</p>
      <Link to="/" className="mt-6 inline-flex rounded-full bg-brand-ink px-5 py-2 text-sm font-semibold text-white">Back home</Link>
    </div>
  );
}
